// mixcloudContext.js

import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducer from './reducers/reducers';

const store = createStore(reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );

const RmsProvider = ({ children }) => {
    return <Provider store={store}>{children}</Provider>;
};

export default RmsProvider;